module.exports = __webpack_public_path__ + "static/Advantage02@2x.d90cbb2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage02@2x.png
// module id = 687
// module chunks = 216210090109534